import { Injectable } from '@angular/core';

@Injectable({ providedIn: "root"})
export class KlaDynamicScriptLoaderService {

    private scripts: any = [];
    private alreadyLoaded: string[] = [];

    load(scriptsUrls: string[]) {

        scriptsUrls.forEach((scruptUrl: any) => {
            this.scripts.push({
                loaded: false,
                src: scruptUrl
            });
        });

        const promises: any[] = [];
        this.scripts.forEach(script => {
            if (!this.alreadyLoaded.includes(script.src)) {
                promises.push(this.loadScript(script));
                this.alreadyLoaded.push(script.src);
            }
        });
        return Promise.all(promises);
    }

    loadScript(scriptObj: any = {}) {
        return new Promise((resolve, reject) => {
            if (!scriptObj.loaded) {
                //load script
                let script: any = document.createElement('script');
                script.type = 'text/javascript';
                script.src = scriptObj.src;
                if (script.readyState) {  //IE
                    script.onreadystatechange = () => {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            scriptObj.loaded = true;
                            resolve({ loaded: true, status: 'Loaded' });
                        }
                    };
                } else {  //Others
                    script.onload = () => {
                        scriptObj.loaded = true;
                        resolve({ loaded: true, status: 'Loaded' });
                    };
                }
                script.onerror = (error: any) => {
                    resolve({ loaded: false, status: 'Loaded' });
                }
                document.getElementsByTagName('head')[0].appendChild(script);
            } else {
                resolve({ loaded: true, status: 'Already Loaded' });
            }
        });
    }

}